"use client"

import { useState } from "react"
import { Box, Grid, Paper, List, ListItem, ListItemText, Typography, Pagination } from "@mui/material"
import { HorizontalBarChart } from "../../components/horizontal-bar-chart"
import { PieChart } from "../attendance/pie-chart"

const CHART_CONTAINER_HEIGHT = 300
const ITEMS_PER_PAGE = 5

const companiesData = [
  { id: "1", label: "Empresa 1", value: 120, color: "rgba(34, 197, 94, 0.7)" },
  { id: "2", label: "Empresa 2", value: 85, color: "rgba(34, 197, 94, 0.7)" },
  { id: "3", label: "Empresa 3", value: 200, color: "rgba(34, 197, 94, 0.7)" },
  { id: "4", label: "Empresa 4", value: 5, color: "rgba(34, 197, 94, 0.7)" },
]

const registrationStatusByCompany: Record<
  string,
  { id: string; label: string; value: number; color?: string }[]
> = {
  "1": [
    { id: "reg-1", label: "Registrados", value: 80, color: "rgba(168, 85, 247, 0.8)" },
    { id: "unreg-1", label: "No Registrados", value: 40, color: "rgba(251, 146, 60, 0.8)" },
  ],
  "2": [
    { id: "reg-2", label: "Registrados", value: 55, color: "rgba(168, 85, 247, 0.8)" },
    { id: "unreg-2", label: "No Registrados", value: 30, color: "rgba(251, 146, 60, 0.8)" },
  ],
  "3": [
    { id: "reg-3", label: "Registrados", value: 150, color: "rgba(168, 85, 247, 0.8)" },
    { id: "unreg-3", label: "No Registrados", value: 50, color: "rgba(251, 146, 60, 0.8)" },
  ],
  "4": [
    { id: "reg-3", label: "Registrados", value: 0, color: "rgba(168, 85, 247, 0.8)" },
    { id: "unreg-3", label: "No Registrados", value: 5, color: "rgba(251, 146, 60, 0.8)" },
  ],
}

const usersByCompanyAndCategory: Record<
  string,
  Record<string, { id: string; name: string }[]>
> = {
  "1": {
    registered: [
      { id: "u1-1", name: "Colaborador 1" },
      { id: "u1-2", name: "Colaborador 2" },
      { id: "u1-3", name: "Colaborador 3" },
      { id: "u1-4", name: "Colaborador 4" },
      { id: "u1-5", name: "Colaborador 5" },
      { id: "u1-6", name: "Colaborador 6" },
    ],
    unregistered: [
      { id: "u1-7", name: "Colaborador 7" },
      { id: "u1-8", name: "Colaborador 8" },
      { id: "u1-9", name: "Colaborador 9" },
    ],
  },
  "2": {
    registered: [
      { id: "u1-1", name: "Colaborador 1" },
      { id: "u1-2", name: "Colaborador 2" },
      { id: "u1-3", name: "Colaborador 3" },
    ],
    unregistered: [
      { id: "u1-1", name: "Colaborador 4" },
      { id: "u1-2", name: "Colaborador 5" },
      { id: "u1-3", name: "Colaborador 6" },
    ],
  },
  "3": {
    registered: [
      { id: "u1-1", name: "Colaborador 1" },
      { id: "u1-2", name: "Colaborador 2" },
      { id: "u1-3", name: "Colaborador 3" },
      { id: "u1-4", name: "Colaborador 4" },
      { id: "u1-5", name: "Colaborador 5" },
      { id: "u1-6", name: "Colaborador 6" },
    ],
    unregistered: [
      { id: "u1-7", name: "Colaborador 7" },
      { id: "u1-8", name: "Colaborador 8" },
    ],
  },
  "4": {
    registered: [
    ],
    unregistered: [
      { id: "u1-1", name: "Colaborador 1" },
      { id: "u1-2", name: "Colaborador 2" },
      { id: "u1-3", name: "Colaborador 3" },
      { id: "u1-4", name: "Colaborador 4" },
      { id: "u1-5", name: "Colaborador 5" },
    ],
  },
}

export function PaymentSlipts() {
  const [selectedCompany, setSelectedCompany] = useState(0)
  const [selectedCategory, setSelectedCategory] = useState(0)
  const [page, setPage] = useState(1)

  const currentCompanyId = companiesData[selectedCompany]?.id || "1"
  const registrationData = registrationStatusByCompany[currentCompanyId]

  const categoryKey = selectedCategory === 0 ? "registered" : "unregistered"
  const users = usersByCompanyAndCategory[currentCompanyId]?.[categoryKey] || []

  const totalPages = Math.ceil(users.length / ITEMS_PER_PAGE)
  const paginatedUsers = users.slice((page - 1) * ITEMS_PER_PAGE, page * ITEMS_PER_PAGE)

  const handleCompanyChange = (index: number) => {
    setSelectedCompany(index)
    setSelectedCategory(0)
    setPage(1)
  }

  const handleCategoryChange = (index: number) => {
    setSelectedCategory(index)
    setPage(1)
  }

  const handlePageChange = (_event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value)
  }

  return (
    <Box sx={{ width: "100%", height: "100%", display: "flex", flexDirection: "column", p: 3, gap: 3 }}>
      <Grid container spacing={2} sx={{ height: CHART_CONTAINER_HEIGHT }}>
        <Grid item sx={{ width: "50%" }}>
          <Paper sx={{ p: 2, height: "100%", display: "flex", flexDirection: "column" }}>
            <HorizontalBarChart
              title="Empresas"
              data={companiesData}
              selectedIndex={selectedCompany}
              onSelect={handleCompanyChange}
              barThickness={30}
            />
          </Paper>
        </Grid>

        <Grid item sx={{ width: "50%" }}>
          <Paper sx={{ p: 2, height: "100%", display: "flex", flexDirection: "column" }}>
            <PieChart
              title="Usuarios Registrados vs No Registrados"
              data={registrationData}
              selectedIndex={selectedCategory}
              onSelect={handleCategoryChange}
            />
          </Paper>
        </Grid>
      </Grid>

      <Paper sx={{ p: 2, flex: 1, display: "flex", flexDirection: "column", minHeight: 0 }}>
        <Typography variant="h6" sx={{ color: "#2563eb", fontWeight: 600, mb: 2 }}>
          {selectedCategory === 0 ? "Usuarios Registrados" : "Usuarios No Registrados"} -{" "}
          {companiesData[selectedCompany].label}
        </Typography>

        {users.length === 0 ? (
          <Typography sx={{ textAlign: "center", py: 4 }}>No hay usuarios en esta categoría</Typography>
        ) : (
          <>
            <List sx={{ flex: 1, overflow: "auto" }}>
              {paginatedUsers.map((user) => (
                <ListItem key={user.id} divider>
                  <ListItemText primary={user.name} />
                </ListItem>
              ))}
            </List>

            {totalPages > 1 && (
              <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
                <Pagination
                  count={totalPages}
                  page={page}
                  onChange={handlePageChange}
                  color="primary"
                />
              </Box>
            )}
          </>
        )}
      </Paper>
    </Box>
  )
}